(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = this.closest('.announcement-bar-section');
      this.header = document.querySelector('.section-header');
      this.closeButton = document.querySelector('.utility-bar__close-button');

      this.closeButton.addEventListener('click', this.closeAnnouncementBar.bind(this));

      this.setAnnouncementBarHeight();
      window.addEventListener('resize', this.setAnnouncementBarHeight.bind(this));
    }

    setAnnouncementBarHeight() {
      document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`);
      document.documentElement.style.setProperty(
        '--negative-announcement-bar-height',
        `-${this.announcementBar.offsetHeight}px`,
      );
      this.header.classList.add('adjust-header-position');
    }

    closeAnnouncementBar() {
      // TODO: should we save that the user closed the bar in a cookie so it doesn't appear again?
      this.announcementBar.classList.add('is-closed');
      // Fix when the navbar is transparent
      this.header.style.top = 0;
      setTimeout(() => {
        this.announcementBar.remove();
      }, 500);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const DURATION_LONG = 500;
  const MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER = 500;
  const BOTTOM_MARGIN = 300;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.bottomLogoIsSticky = false;
      this.isResizing = false;
      this.isNavigationOpening = false;
      this.observer = null; // Track the observer instance
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.stickyBottomLogo = document.querySelector('[data-sticky-logo-section-visible]');

      this.setHeaderHeight();

      this.isMobile = window.matchMedia('(max-width: 1023px)').matches;

      const isPageTooShortOnMobile =
        this.isMobile && document.body.scrollHeight - window.innerHeight <= MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER;
      if (isPageTooShortOnMobile) {
        document.querySelector('body')?.setAttribute('data-sticky-logo-section-visible', 'true');
      }

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.onResizeHandler = this.onResize.bind(this);
      window.addEventListener('resize', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    onResize() {
      this.isResizing = true;

      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.reset();

      this.resizeTimeout = setTimeout(() => {
        this.setHeaderHeight();
        this.createObserver(); // This will now properly clean up the previous observer
        this.isResizing = false;
      }, 150);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
    }

    createObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
      });

      this.observer.observe(this.header);
    }

    checkStickyBottomLogo() {
      if (!this.stickyBottomLogo || this.isResizing || this.isNavigationOpening) return;

      const parent = this.stickyBottomLogo.parentElement;
      const logoRect = this.stickyBottomLogo.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();
      const logoSectionThreshold = 300;

      this.bottomLogoIsSticky = logoRect.bottom + logoSectionThreshold >= parentRect.bottom;
    }

    onScroll() {
      const isPageTooShort = document.body.scrollHeight - window.innerHeight <= MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER;
      if (this.isResizing || isPageTooShort) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // If header is still opening, but we reach the top of the page, reset immediately
      if (this.isNavigationOpening) {
        if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.checkStickyBottomLogo();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const triggerBottom = this.headerBounds.bottom + BOTTOM_MARGIN;

      if (scrollTop > this.currentScrollTop && scrollTop > triggerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > triggerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal && !this.bottomLogoIsSticky) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      const leftMenuOverlay = document.querySelector('#Menu-left-Overlay .menu-overlay-container');
      const isMenuOpen = leftMenuOverlay && leftMenuOverlay.classList.contains('is-open');

      const isPageTooShortOnMobile =
        this.isMobile && document.body.scrollHeight - window.innerHeight <= MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER;
      if (isPageTooShortOnMobile) return;

      if (this.headerIsAlwaysSticky || this.isResizing || this.isNavigationOpening || isMenuOpen) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.querySelector('body')?.setAttribute('data-sticky-logo-section-visible', 'true');
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.isResizing || this.isNavigationOpening) return;

      this.isNavigationOpening = true;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      const isPageTooShortOnMobile =
        this.isMobile && document.body.scrollHeight - window.innerHeight <= MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER;
      if (!this.bottomLogoIsSticky && !isPageTooShortOnMobile) {
        document.querySelector('body')?.setAttribute('data-sticky-logo-section-visible', 'false');
      }

      this.isScrolling = setTimeout(() => {
        this.isNavigationOpening = false;
      }, DURATION_LONG);
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.isResizing) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.isNavigationOpening = false;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-settings"]) return;
  try {
    
  class MainSettings extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.headerElement = document.querySelector('.shopify-section.section-header');
      this.announcementBarElement = document.querySelector('.announcement-bar-section');
    }
  }

  customElements.define('main-settings', MainSettings);

  } catch(e) { console.error(e); }
})();
})();
